import {
  SheetGeometryCategory,
  SheetGeometryWainscotingPlanCategories,
} from "building-types/views/sheetGeometryCategory";

const builtInPropSheetGeometryCategories = [
  SheetGeometryCategory.PROP_APPLIANCES,
  SheetGeometryCategory.PROP_FIXTURES,
  SheetGeometryCategory.PROP_OTHER,
];

export const FloorPlanTagOrder = Object.freeze([
  SheetGeometryCategory.SLAB_PATIO,

  SheetGeometryCategory.RAILING_PROJECTED,
  SheetGeometryCategory.RAILING_ABOVE,
  SheetGeometryCategory.RAILING_POST,

  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.PROP_TAG,
  SheetGeometryCategory.PORCH_COLUMNS,
  SheetGeometryCategory.PORCH_BEAMS,
  SheetGeometryCategory.PORCH,
  SheetGeometryCategory.DECK,
  SheetGeometryCategory.PERIMS_WALL,

  SheetGeometryCategory.WALL_CORE,
  SheetGeometryCategory.WALL_SUBSTRATE,
  SheetGeometryCategory.WALL_EXTERIOR_FINISH,

  SheetGeometryCategory.CHASE_ROOMS,
  SheetGeometryCategory.STEM_WALL_UNIONED_EDGES,
  SheetGeometryCategory.PIER_HIDDEN,
  SheetGeometryCategory.PIER,

  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,

  SheetGeometryCategory.RAILING_PROJECTED_STAIR_ONLY,
  SheetGeometryCategory.RAILING_ABOVE_STAIR_ONLY,
  SheetGeometryCategory.RAILING_POST_STAIR_ONLY,

  SheetGeometryCategory.CASEWORK,

  SheetGeometryCategory.CEILING,
  ...SheetGeometryWainscotingPlanCategories,
  SheetGeometryCategory.DOOR_OPERATION_LINEWORK,
  SheetGeometryCategory.DOORS,
  SheetGeometryCategory.WINDOWS,
  SheetGeometryCategory.COLUMN,
  SheetGeometryCategory.ELECTRICAL_CONTROLLERS,

  SheetGeometryCategory.ROOM_LABELS,
  SheetGeometryCategory.CASEWORK_TAG,
  SheetGeometryCategory.WINDOW_TAGS,
  SheetGeometryCategory.DOOR_TAGS,
  // HEADER_FRAMING_TAGS is intentionally NOT included here — it must stay off by
  // default in built-in plansets. The editor viewer renders it through its own
  // stage (renderEditorViewerHeaderFramingTags) and Procure's FRAMING_HEADER view
  // opts in via its own viewTags list.

  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_NOTE,

  SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK,
  SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS,
  SheetGeometryCategory.WALL_EXTERIOR_DIM_TICK,
  SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL,

  SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK,
  SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS,
  SheetGeometryCategory.WALL_INTERIOR_DIM_TICK,
  SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL,

  SheetGeometryCategory.ANNOT_DIM_LABEL,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_TICK,
]);

export const FoundationPlanTagOrder = Object.freeze([
  SheetGeometryCategory.FOOTING,
  SheetGeometryCategory.SLAB_BELOW,
  SheetGeometryCategory.SLAB_ABOVE,
  SheetGeometryCategory.BRICKLEDGE_PROJECTED,
  SheetGeometryCategory.BRICKLEDGE_CUT,
  SheetGeometryCategory.FOUNDATION_CURB,
  SheetGeometryCategory.STAIR_WALLS,
  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,

  SheetGeometryCategory.STEM_WALL_BELOW,
  SheetGeometryCategory.STEM_WALL_ABOVE,
  SheetGeometryCategory.STEM_WALL_ABOVE_GAPS,

  SheetGeometryCategory.PIER_HIDDEN,
  SheetGeometryCategory.PIER,
  SheetGeometryCategory.ELECTRICAL_LOADS,
  SheetGeometryCategory.ELECTRIC_LOAD_LABEL,
  SheetGeometryCategory.ELECTRICAL_CONTROLLERS,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.PROP_TAG,
  SheetGeometryCategory.COLUMN,
  SheetGeometryCategory.FOUNDATION_DASHED_LINEWORK,
  SheetGeometryCategory.FOUNDATION_SOLID_LINEWORK,

  SheetGeometryCategory.FOUNDATION_DIM_LINEWORK,
  SheetGeometryCategory.FOUNDATION_DIM_WITNESS,
  SheetGeometryCategory.FOUNDATION_DIM_TICK,

  SheetGeometryCategory.CONDITION_TAG,
  SheetGeometryCategory.CEILING,

  SheetGeometryCategory.SLAB_TAG,

  SheetGeometryCategory.FOUNDATION_DIM_LABEL,

  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_NOTE,
  SheetGeometryCategory.ANNOT_DIM_LABEL,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ANNOT_DIM_TICK,
]);

export const FoundationUtilityPlanTagOrderWithUtilitySlab = Object.freeze([
  SheetGeometryCategory.SLAB_BELOW,
  SheetGeometryCategory.ELECTRICAL_LOADS,
  SheetGeometryCategory.ELECTRIC_LOAD_LABEL,
  SheetGeometryCategory.ELECTRICAL_CONTROLLERS,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.PROP_TAG,
  SheetGeometryCategory.CEILING,
  SheetGeometryCategory.UTILITY_DIM_TICK,
  SheetGeometryCategory.UTILITY_DIM_LINEWORK,
  SheetGeometryCategory.UTILITY_DIM_WITNESS,
  SheetGeometryCategory.UTILITY_FOUNDATION_LINEWORK,
  SheetGeometryCategory.ALL_LVL_ANNOT_LINEWORK,
  SheetGeometryCategory.SLAB_TAG,
  SheetGeometryCategory.ALL_LVL_ANNOT_DETAIL,
  SheetGeometryCategory.ALL_LVL_ANNOT_NOTE,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_TICK,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_LABEL,
  SheetGeometryCategory.UTILITY_DIM_LABEL,
]);

export const FoundationUtilityPlanTagOrderWithFoundationOutline = Object.freeze([
  SheetGeometryCategory.FOUNDATION_OUTLINE,
  SheetGeometryCategory.ELECTRICAL_LOADS,
  SheetGeometryCategory.ELECTRIC_LOAD_LABEL,
  SheetGeometryCategory.ELECTRICAL_CONTROLLERS,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.PROP_TAG,
  SheetGeometryCategory.CEILING,
  SheetGeometryCategory.UTILITY_DIM_TICK,
  SheetGeometryCategory.UTILITY_DIM_LINEWORK,
  SheetGeometryCategory.UTILITY_DIM_WITNESS,
  SheetGeometryCategory.UTILITY_FOUNDATION_LINEWORK,
  SheetGeometryCategory.ALL_LVL_ANNOT_LINEWORK,
  SheetGeometryCategory.SLAB_TAG,
  SheetGeometryCategory.ALL_LVL_ANNOT_DETAIL,
  SheetGeometryCategory.ALL_LVL_ANNOT_NOTE,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_TICK,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_LABEL,
  SheetGeometryCategory.UTILITY_DIM_LABEL,
]);

export const FloorPlanMaterialsTagOrder = Object.freeze([
  SheetGeometryCategory.FLOOR_FINISH,
  SheetGeometryCategory.PORCH_COLUMNS,
  SheetGeometryCategory.PORCH_BEAMS,
  SheetGeometryCategory.PORCH,
  SheetGeometryCategory.DOOR_OPERATION_LINEWORK,
  SheetGeometryCategory.DOORS,
  SheetGeometryCategory.WINDOWS,
  SheetGeometryCategory.PERIMS_WALL,
  SheetGeometryCategory.WALL_CORE,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.CASEWORK,
  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,
  SheetGeometryCategory.RAILING_PROJECTED,
  SheetGeometryCategory.RAILING_ABOVE,
  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_NOTE,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_TICK,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ANNOT_DIM_LABEL,
]);

export const FloorPlanSummaryTagOrder = Object.freeze([
  SheetGeometryCategory.FLOOR_AREA_CONDITIONED,
  SheetGeometryCategory.FLOOR_AREA_UNCONDITIONED,
  SheetGeometryCategory.PORCH_COLUMNS,
  SheetGeometryCategory.PORCH_BEAMS,
  SheetGeometryCategory.DOOR_OPERATION_LINEWORK,
  SheetGeometryCategory.DOORS,
  SheetGeometryCategory.WINDOWS,
  SheetGeometryCategory.PERIMS_WALL,
  SheetGeometryCategory.PERIMS_FLOORPLATE,
  SheetGeometryCategory.WALL_CORE,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.CASEWORK,
  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,
  SheetGeometryCategory.RAILING_PROJECTED,
  SheetGeometryCategory.RAILING_ABOVE,
  SheetGeometryCategory.RAILING_POST,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_NOTE,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_TICK,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ANNOT_DIM_LABEL,
]);

export const EmptyFloorPlanSummaryTagOrder = Object.freeze([]);

export const BrochureFloorPlanSummaryTagOrder = Object.freeze([
  SheetGeometryCategory.SLAB_PATIO,
  SheetGeometryCategory.PORCH_COLUMNS,
  SheetGeometryCategory.PORCH_BEAMS,
  SheetGeometryCategory.WINDOWS,
  SheetGeometryCategory.PERIMS_WALL,
  SheetGeometryCategory.WALL_CORE,
  SheetGeometryCategory.DOOR_OPERATION_LINEWORK,
  SheetGeometryCategory.DOORS,
  SheetGeometryCategory.CHASE_ROOMS,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.CASEWORK_SOLID_DASH,
  SheetGeometryCategory.CASEWORK_POCHE,
  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,
  SheetGeometryCategory.RAILING_PROJECTED,
  SheetGeometryCategory.RAILING_ABOVE,
  SheetGeometryCategory.STEM_WALL_UNIONED_EDGES,
  SheetGeometryCategory.PIER_HIDDEN,
  SheetGeometryCategory.PIER,
  SheetGeometryCategory.CEILING,
  SheetGeometryCategory.ELECTRICAL_CONTROLLERS,
  SheetGeometryCategory.ELECTRICAL_LOADS,
  SheetGeometryCategory.ELECTRIC_LOAD_LABEL,
  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_NOTE,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_TICK,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ANNOT_DIM_LABEL,
  SheetGeometryCategory.ROOM_LABELS,
  SheetGeometryCategory.COLUMN,
]);

export const StructuralPlanTagOrder = Object.freeze([
  SheetGeometryCategory.PORCH_COLUMNS,
  SheetGeometryCategory.PORCH_BEAMS,
  SheetGeometryCategory.PORCH,
  SheetGeometryCategory.SLAB_PATIO,
  SheetGeometryCategory.WALL_CORE,
  SheetGeometryCategory.STEM_WALL_UNIONED_EDGES,
  SheetGeometryCategory.PIER_HIDDEN,
  SheetGeometryCategory.PIER,
  SheetGeometryCategory.CHASE_ROOMS,
  SheetGeometryCategory.DOOR_OPERATION_LINEWORK,
  SheetGeometryCategory.DOORS,
  SheetGeometryCategory.WINDOWS,
  SheetGeometryCategory.PERIMS_WALL,
  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_NOTE,
  SheetGeometryCategory.ANNOT_DIM_LABEL,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ANNOT_DIM_TICK,
  SheetGeometryCategory.CEILING,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.PROP_TAG,
  SheetGeometryCategory.CASEWORK,
  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,
  SheetGeometryCategory.RAILING_PROJECTED,
  SheetGeometryCategory.RAILING_ABOVE,
  SheetGeometryCategory.RAILING_POST,
  SheetGeometryCategory.ROOM_LABELS,
  SheetGeometryCategory.COLUMN,
  SheetGeometryCategory.PERIMS_FLOORPLATE,
  SheetGeometryCategory.FLOOR_FRAMING,
  SheetGeometryCategory.FLOOR_FRAMING_LABEL,
  SheetGeometryCategory.FLOOR_SYSTEM_TAG,
  SheetGeometryCategory.SUB_FLOORING,
  SheetGeometryCategory.ROOF_FRAMING,
]);

export const ElectricalPlanTagOrder = Object.freeze([
  SheetGeometryCategory.PORCH_COLUMNS,
  SheetGeometryCategory.PORCH_BEAMS,
  SheetGeometryCategory.PORCH,
  SheetGeometryCategory.SLAB_PATIO,
  SheetGeometryCategory.WALL_CORE,
  SheetGeometryCategory.STEM_WALL_UNIONED_EDGES,
  SheetGeometryCategory.PIER_HIDDEN,
  SheetGeometryCategory.PIER,
  SheetGeometryCategory.CHASE_ROOMS,
  SheetGeometryCategory.DOOR_OPERATION_LINEWORK,
  SheetGeometryCategory.DOORS,
  SheetGeometryCategory.WINDOWS,
  SheetGeometryCategory.PERIMS_WALL,
  SheetGeometryCategory.CEILING,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.PROP_TAG,
  SheetGeometryCategory.CASEWORK,
  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,
  SheetGeometryCategory.RAILING_PROJECTED,
  SheetGeometryCategory.RAILING_ABOVE,
  SheetGeometryCategory.ELECTRICAL_LINKS,
  SheetGeometryCategory.ELECTRICAL_LOADS,
  SheetGeometryCategory.ELECTRIC_LOAD_LABEL,
  SheetGeometryCategory.ELECTRICAL_CONTROLLERS,
  SheetGeometryCategory.ANNOT_DETAIL,
  SheetGeometryCategory.ANNOT_LINEWORK,
  SheetGeometryCategory.ANNOT_NOTE,
  SheetGeometryCategory.ANNOT_DIM_LABEL,
  SheetGeometryCategory.ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ANNOT_DIM_TICK,
  SheetGeometryCategory.ROOM_LABELS,
  SheetGeometryCategory.COLUMN,
]);

export const RoofPlanTagOrder = Object.freeze([
  SheetGeometryCategory.ROOF,
  SheetGeometryCategory.ROOF_PERIMS,
  SheetGeometryCategory.ROOF_RIDGE_VENT,
  SheetGeometryCategory.SKYLIGHTS,
  SheetGeometryCategory.CEILING,
  SheetGeometryCategory.ROOF_RIDGE_VENT_ANNOS,
  SheetGeometryCategory.ROOF_SLOPE_ANNOS,
  SheetGeometryCategory.ROOF_SKYLIGHT_ANNOS,
  SheetGeometryCategory.ROOF_OVERHANG_DIM_LINEWORK,
  SheetGeometryCategory.ROOF_OVERHANG_DIM_TICK,
  SheetGeometryCategory.ROOF_OVERHANG_DIM_WITNESS,
  SheetGeometryCategory.ROOF_OVERHANG_DIM_LABEL,
]);

export const BackgroundPlanTagOrder = Object.freeze([
  SheetGeometryCategory.PORCH_COLUMNS,
  SheetGeometryCategory.PORCH_BEAMS,
  SheetGeometryCategory.PORCH,
  SheetGeometryCategory.SLAB_PATIO,
  SheetGeometryCategory.STEM_WALL_UNIONED_EDGES,
  SheetGeometryCategory.PIER_HIDDEN,
  SheetGeometryCategory.PIER,
  SheetGeometryCategory.DOORS,
  SheetGeometryCategory.DOOR_OPERATION_LINEWORK,
  SheetGeometryCategory.WINDOWS,
  SheetGeometryCategory.PERIMS_WALL,
  SheetGeometryCategory.WALL_CORE,
  SheetGeometryCategory.CHASE_ROOMS,
  SheetGeometryCategory.COLUMN,
  SheetGeometryCategory.ALL_LVL_ANNOT_DETAIL,
  SheetGeometryCategory.ALL_LVL_ANNOT_LINEWORK,
  SheetGeometryCategory.ALL_LVL_ANNOT_NOTE,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_LABEL,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_LINEWORK,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_WITNESS,
  SheetGeometryCategory.ALL_LVL_ANNOT_DIM_TICK,
  SheetGeometryCategory.CEILING,
  ...builtInPropSheetGeometryCategories,
  SheetGeometryCategory.PROP_TAG,
  SheetGeometryCategory.CASEWORK,
  SheetGeometryCategory.STAIR_PROJECTED,
  SheetGeometryCategory.STAIR_ABOVE,
  SheetGeometryCategory.RAILING_PROJECTED,
  SheetGeometryCategory.RAILING_ABOVE,
  SheetGeometryCategory.RAILING_POST,
]);
